export default __webpack_public_path__ + "static/media/kolkata1.b3bf2beb.jpg";